<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/reform',title:'改制单列表'},{title:'改制审批'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>改制需求</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="改制需求号" class="h-elformWrap-2" prop="reformId">
                                                <el-input v-model="f.reformId" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                                                <el-input v-model="f.agentCode" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                                                <el-input placeholder="输入经销商编码自动带出" v-model="f.agentName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaName">
                                                <el-input v-model="f.areaName" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqunName">
                                                <el-input v-model="f.lianqunName" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="materialCode">
                                                <el-input v-model="f.materialCode" placeholder="请输入" readonly>
                                                </el-input>
                                            </el-form-item>

                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="materialName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.materialName" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="数量" class="h-elformWrap-2" prop="number">
                                                <el-input placeholder="请输入"v-model.number="f.number" readonly></el-input>
                                            </el-form-item>

                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="oneLName">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.oneLName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="单台加价" class="h-elformWrap-2" prop="reformPrice">
                                                <el-input  placeholder="选择改制信息自动计算" v-model="f.reformPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理工号" class="h-elformWrap-2" prop="typeUserCode">
                                                <el-input placeholder="请输入工号" v-model="f.typeUserCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理名称" class="h-elformWrap-2" prop="typeUserName">
                                                <el-input placeholder="输入工号自动带出" v-model="f.typeUserName"  readonly ></el-input>
                                            </el-form-item>

                                            <el-form-item label="型号经理工号" class="h-elformWrap-2" prop="typeUserCode">
                                                <el-input placeholder="请输入工号" v-model="f.typeUserCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="型号经理名称" class="h-elformWrap-2" prop="typeUserName">
                                                <el-input placeholder="输入工号自动带出" v-model="f.typeUserName" readonly ></el-input>
                                            </el-form-item>
                                            <el-form-item
                                                    label="生产日期"
                                                    class="h-elformWrap-2"
                                                    prop="produceTime">
                                                <div class="block">
                                                    <el-date-picker
                                                            v-model="f.produceTime"
                                                            type="date"
                                                            :clearable="false"
                                                            value-format="yyyy-MM-dd"
                                                            placeholder="--请先选择生产日期--"
                                                            :picker-options="startDateLimit">
                                                    </el-date-picker>
                                                </div>
                                            </el-form-item>


                                            <el-form-item label="备注" class="h-elformWrap-2" prop="remark">
                                                <el-input  v-model="f.remark" ></el-input>
                                            </el-form-item>
                                            <el-form-item label="附件" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="附件"
                                                        :uploadflag="false"
                                                        :delflag="false"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <div>

                                                <div v-for="(listIt, index) in f.specificList" :key="index" class="h-formBox">

                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-input  v-model="f.specificList[index].specificDivision" readonly></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-input  v-model="f.specificList[index].specificReform" readonly></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="f.specificList[index].reformNum"></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="由财务填写" v-model="f.specificList[index].reformPrice" readonly></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="N-chan">
                                    <div class="h-pieceTitle2">
                                        <h1>改制确认</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <i @click="addIndividualize()" style="float:right;font-size:20px;margin-right: 30% " class="el-icon-circle-plus"></i>
                                            <div v-for="(listIt, index) in f.individualizeList" :key="index" class="h-formBox">
                                                <i @click="deleteIndividualize(index)" v-show="index != 0" style="float:right;font-size:20px;margin-right: 30%;color:crimson;"
                                                   class="el-icon-remove"></i>
                                                <el-form-item  class="h-elformWrap-35" >
                                                    <template slot="label">
                                                        个性化定制标准描述{{index+1}}
                                                    </template>
                                                    <el-input placeholder="由型号经理填写" v-model="f.individualizeList[index]" ></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <i @click="addLogoRequest()" style="float:right;font-size:20px;margin-right: 30%" class="el-icon-circle-plus"></i>
                                            <div v-for="(listIt, index) in f.logoRequestList" :key="index" class="h-formBox">
                                                <i @click="deleteLogoRequest(index)" v-show="index != 0" style="float:right;font-size:20px;margin-right: 30%;color:crimson;"
                                                   class="el-icon-remove"></i>
                                                <el-form-item  class="h-elformWrap-35" >
                                                    <template slot="label">
                                                        包装标识要求{{index+1}}
                                                    </template>
                                                    <el-input placeholder="由型号经理填写" v-model="f.logoRequestList[index]" ></el-input>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="改制类型" class="h-elformWrap-2" prop="reformType" >
                                                <el-select  v-model="f.reformType" >
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" >
                                                <el-select  @change="handleItemChange1" v-model="f.reformEdition" placeholder="请选择">
                                                    <el-option
                                                            v-for="item in reformEditionList"
                                                            :key="item.VERID"
                                                            :label="item.VERID +'-'+ item.TEXT1"
                                                            :value="item.VERID">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                <el-checkbox-group v-model="f.stationlist" >
                                                    <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                            <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="f.checkRequest"></el-input>
                                            </el-form-item>
                                            <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                <brupload
                                                        :refid="f.id"
                                                        reftype="改制明细测试报告"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>


                                </div>
                                <el-button
                                        class="h-btn h-formBtn h-bgblueQ"
                                        icon="h-el-icon h-el-icon-export"
                                        style="margin:20px"
                                        @click="uploaddownexcelflagbtn"
                                       >
                                    改制物料明细导入
                                </el-button>
                                <uploaddownexcel
                                        :visible.sync="uploaddownexcelflag"
                                        v-if="uploaddownexcelflag"
                                        clsname="reformMainDetailImportExcel"
                                        :startrow="2"
                                        :extparams="{id:f.id,number:f.number}"
                                        @callback="uploadExcelFilecallback"/>
                                <el-table
                                        ref="multipleTable"
                                        :data="f.reformMainDetailList"
                                        border
                                        style="width: 100%">
                                    <el-table-column label="个性化改制物料明细">
                                        <el-table-column
                                                prop="orderby"
                                                label="序号"
                                                width="50">
                                            <template slot-scope="scope">
                                                {{scope.row.orderby}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialName"
                                                label="物料描述"
                                                width="180">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialName" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCode"
                                                label="物料专用号"
                                                width="140">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialCode" @change="getSupplier(scope.row)" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="purchaseGroup"
                                                label="采购组"
                                                width="110">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.purchaseGroup" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialOrder"
                                                label="物料单耗"
                                                width="180">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialOrder" @change="changeDh(scope.row)" placeholder="请输入" ></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unit"
                                                label="单位"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unit" placeholder="单位"></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="numbermb"
                                                label="模板导入数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numbermb" @change="changeMb(scope.row)" placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numberjs"
                                                label="系统计算数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numberjs" disabled placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="number"
                                                label="最终使用数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.number" disabled placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="isSelf"
                                                label="自制/外购"
                                                width="150"
                                                :show-overflow-tooltip="true">
                                            <template slot-scope="scope">
                                                <el-select v-model="scope.row.isSelf" @visible-change="$forceUpdate()" placeholder="--请选择产品型号--" >
                                                    <el-option label="自制" value="1"></el-option>
                                                    <el-option label="外购" value="0"></el-option>
                                                    <el-option label="外购-厂家改制" value="2"></el-option>
                                                    <el-option label="外购-到厂改制" value="3"></el-option>
                                                </el-select>
                                            </template>
                                        </el-table-column>


                                        <el-table-column
                                                prop="remark"
                                                label="备注"
                                                width="300">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.remark" placeholder="备注"> </el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="supplierName"
                                                label="供应商名称"
                                                width="150">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.supplierName" placeholder="供应商名称"> </el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="图纸"
                                                :show-overflow-tooltip="true"
                                                fixed
                                                min-width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                        :refid="scope.row.id"
                                                        reftype="改制物料明细"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false">
                                                </brupload>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="changeDes"
                                                label="变更描述"
                                                width="300">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.changeDes" placeholder="变更描述"> </el-input>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>
                                    <el-table-column label="替换物料明细">
                                        <el-table-column
                                                prop="materialNameTh"
                                                label="物料描述"
                                                width="180">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialNameTh" placeholder="物料描述"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="materialCodeTh"
                                                label="物料专用号"
                                                width="140">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.materialCodeTh" @change="getSupplierTh(scope.row)" placeholder="物料专用号"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="unitTh"
                                                label="单位"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.unitTh" placeholder="单位"></el-input>
                                            </template>
                                        </el-table-column>
                                      <!--  <el-table-column
                                                prop="numbermbTh"
                                                label="模板导入数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numbermbTh" @change="changeMbTh(scope.row)" placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="numberjsTh"
                                                label="系统计算数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numberjsTh" disabled placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>-->
                                        <el-table-column
                                                prop="numberTh"
                                                label="最终使用数量"
                                                width="90">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.numberTh" placeholder="数量"></el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="remarkTh"
                                                label="备注"
                                                width="300">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.remarkTh" placeholder="备注"> </el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="supplierNameTh"
                                                label="供应商名称"
                                                width="150">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.supplierNameTh" placeholder="供应商名称"> </el-input>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="图纸"
                                                :show-overflow-tooltip="true"
                                                fixed
                                                min-width="150">
                                            <template slot-scope="scope">
                                                <brupload
                                                        :refid="scope.row.id"
                                                        reftype="替换物料明细"
                                                        :uploadflag="true"
                                                        :delflag="true"
                                                        :showtime="false">
                                                </brupload>
                                            </template>
                                        </el-table-column>

                                    </el-table-column>
                                    <el-table-column
                                            label="操作"
                                            fixed="right"
                                            width="200">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" v-if="true" @click="delIndex(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="h-tableAdd" @click="adds" >
                                    <a>新增一行</a>
                                </div>
                            </div>


                        </el-form>

                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>审批意见</h1>
                                </div>
                                <div class="h-formLine Yangbiao">
                                    <el-form :model="f" label-position="right" :inline="true"
                                             class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="审批意见" class="h-elformWrap-3 ":required="true">
                                            <el-input v-model="f.shpyj" placeholder="请输入"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="f.instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="zancun">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                <el-button class="el-button h-btn el-button--default" @click="viewpress">审批跟踪</el-button>

            </div>


        </div>
    </div>
</template>

<script>
    import reformService from "../../../api/reform/reformService.js";
    import uploaddownexcel from "../../../components/uploaddown/uploaddownexcel";
    import ss from "../../../api/SystemService";
    import _ from "loadsh";
    import big from "big.js";

    export default {
        components: {
            uploaddownexcel,

        },

        data() {
            return {
                showhistory:false,


                //全部物料工位
                options: [],
                //生产版本list
                reformEditionList:{},

                //导入Excel
                uploaddownexcelflag: false,

                //是否可以选择时间
                startDateLimit: {
                    disabledDate: (time) => {
                        return time.getTime() < Date.now() + 7 * 24 * 3600 * 1000
                    }
                },
                factory:null,

                //带线表单
                f: {
                    agentCode:null, // 经销商编码
                    agentName:null, // 经销商名称
                    areaCode:null, // 区域编码
                    areaName:null, // 区域名称
                    lianqun:null, // 链群`
                    lianqunName:null, // 链群名称
                    materialCode:null, // 物料编码
                    materialName:null, // 物料名称
                    number:null, // 数量
                  /*  specificIds:null, // 改制大id
                    specificDivisions:null,//改制大类
                    specificReqs:null, // 改制大描述*/
                    oneLId:null, // 产品大类编码
                    oneLName:null, // 产品大类名称
                    reformPrice:null, // 定制加价（单台）
                    produceTime:null, // 生产日期
                    instid:null,
                    reformId:null, // 定制编号
                    reformType:'',//0生产改制1库存改制
                    reformEdition:'',//生产版本
                    typeUserCode:null,//型号经理编码
                    typeUserName:null,//型号经理名称
                    materialStation:null,//物料工位
                    individualizeReform:null,//个性化定制标准描述
                    logoRequest:null,//包装标识要求
                    changeRequest:null,
                    //物料明细
                    reformMainDetailList: [{materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',numbermb:'',numberjs:'',isSelf:'',remark:'',
                        materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',id:this.$util.getUuid(),
                        supplierName:'',supplierNameTh:'',changeDes:'',purchaseGroup:'',}],
                    //改制明细
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:0,//改制数量
                    }],

                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],

                    remark:null,//备注
                    //选择的物料工位
                    stationlist:[],
                    //审批相关参数
                    taskid:null,
                    optflag:null,
                    shpyj:null,
                },


                rules: {
                    reformId:[{required: true, message: '需求号必填', trigger: 'change'}],
                    agentCode: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    agentName: [{required: true, message: '请选择经销商', trigger: 'change'}],
                    areaName: [{required: true, message: '请选择区域', trigger: 'change'}],
                    lianqunName: [{required: true, message: '请选择链群', trigger: 'change'}],
                    materialCode: [{required: true, message: '请选择物料', trigger: 'change'}],
                    materialName: [{required: true, message: '请选择物料', trigger: 'change'}],
                    number: [{required: true, message: '请填写数量', trigger: 'change'}],
                    produceTime:[{required: true, message: '请选择生产日期', trigger: 'change'}],
                    oneLName: [{required: true, message: '请填产品大类', trigger: 'change'}],
                    typeUserCode: [{required: true, message: '请填写型号经理工号', trigger: 'change'}],
                    reformType: [{required: true, message: '请选择改制类型', trigger: 'blur'}],
                    reformEdition: [{required: true, message: '请选择生产版本', trigger: 'blur'}],
                    stationlist: [{type: 'array', required: true, message: '请至少选择一个物料工位', trigger: 'change'}],



                },
            }
        },
        created() {
            this.f.taskid = this.$route.query.taskid;
            this.f.id =  this.$route.query.ywid;

            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");
            this.query(this.f.id);
        },
        methods: {

            query(id) {
                reformService.selectById(id).then(rd => {

                    this.f = {...this.f,...rd.obj};

                    //改制明细
                    this.f.specificList = rd.obj.specificList;
                    ///物料工位
                    this.f.stationlist = rd.obj.materialStation? rd.obj.materialStation.split(","): [];

                    //个性化定制标准描述
                    this.f.individualizeList = rd.obj.individualizeReform? rd.obj.individualizeReform.split("##"): [''];

                    //包装标识要求
                    this.f.logoRequestList = rd.obj.logoRequest? rd.obj.logoRequest.split("##"): [''];

                    //获取生产版本
                    this.getReformEdition();
                })
            },

            //返回
            backS() {
                this.$router.push({path: "/chanp/reform"});
            },
            viewpress(r){
                this.showhistory = true;
            },
            //驳回
            auditFail() {

                this.f.optflag = '驳回'
                if(!this.f.shpyj){
                    this.$msg.msge("驳回必须输入审批意见！");
                    return;
                }
                this.$msg.confirm("确认提交？", () => {
                    this.submitForm();
                })

            },
            //获取生产版本
            getReformEdition() {
                let promises = []; // 创建一个存储异步操作的Promise数组
                //根据所选物料获取产地
                let promise = ss.salesList.selectModel(this.f.materialCode).then(rd => {
                    this.factory = rd.factory;
                })
                promises.push(promise); // 将每个异步操作的Promise添加到数组中
                Promise.all(promises) // 等待所有异步操作完成
                    .then(() => {
                        var data = {
                            WERKS: this.factory,
                            MATNR: this.f.materialCode,
                            reformType: "N",
                        }
                        reformService.getSapReformEditionUtil(data).then(rd => {
                            console.log("rd",rd);
                            this.reformEditionList = rd.msg;
                        })
                    });
            },
            handleItemChange1(value){
                this.f.reformEdition = value;
            },
            //通过
            auditPass(){
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                console.log("this.factory",this.factory)
                if(this.factory == '9370' && (
                    this.f.stationlist.includes("2001") || this.f.stationlist.includes("2000") ||
                    this.f.stationlist.includes("2002") || this.f.stationlist.includes("2003")
                ) ){
                    this.$msg.msge("产地为9370的物料库位只可选择7200或7201！");
                    return;
                }
                if(this.factory == '9393' && (this.f.stationlist.includes("7201") || this.f.stationlist.includes("7200")) ){
                    this.$msg.msge("产地为9393的物料库位只可选择2000或2001或2002或2003！");
                    return;
                }
                var msg = '序号';
                var msgflag = false;
                //校验最终数量和模板数量
                var num=1
                for(var i=0;i<this.f.reformMainDetailList.length;i++){

                    console.log(this.f.reformMainDetailList[i].number,this.f.reformMainDetailList[i].numberjs)
                    if(this.f.reformMainDetailList[i].number != this.f.reformMainDetailList[i].numberjs){
                        msgflag = true;
                        msg = msg+","+num;
                    }
                    num++;
                }
                msg = msg+",系统计算数量与提交数量不一致,请确认数据准确性!"
                if (subflag == true) {
                    if(msgflag){
                        this.$msg.confirm(msg, () => {
                            this.f.optflag = '通过'
                            this.$msg.confirm("确认提交？", () => {

                                this.f.materialStation = this.f.stationlist.join(",");

                                this.f.individualizeReform = this.f.individualizeList.join("##");
                                this.f.logoRequest = this.f.logoRequestList.join("##");

                                this.submitForm();
                            })
                        })
                    }else {
                        this.f.optflag = '通过'
                        this.$msg.confirm("确认提交？", () => {

                            this.f.materialStation = this.f.stationlist.join(",");

                            this.f.individualizeReform = this.f.individualizeList.join("##");
                            this.f.logoRequest = this.f.logoRequestList.join("##");

                            this.submitForm();
                        })
                    }

                }
            },
            submitForm() {

                reformService.xinghaojlSp(this.f).then(rd => {
                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回原页面
                        this.$router.go(-1);
                    })
                })
            },

            zancun(){
                if(this.f.stationlist){
                    this.f.materialStation = this.f.stationlist.join(",");
                }
                if(this.f.individualizeList){
                    this.f.individualizeReform = this.f.individualizeList.join("##");
                }
                if(this.f.logoRequestList){
                    this.f.logoRequest = this.f.logoRequestList.join("##");
                }

                reformService.xhZancun(this.f).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
            },

            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.f.reformMainDetailList = rd.obj;
                //自动计算数量  = 产品数量*单耗
                this.f.reformMainDetailList.forEach((item, index) => {
                    //如果入了单耗不为空 但是数量是空就自动计算
                    if(item.materialOrder && !item.number){
                        item.number = item.materialOrder * this.f.number;
                    }
                })

            },

            //增加行
            adds(){
                var a = {
                    materialName:'',materialCode:'',materialOrder:'',unit:'',number:'',isSelf:'',remark:'',
                    materialNameTh:'',materialCodeTh:'',materialOrderTh:'',numberTh:'',remarkTh:'',purchaseGroup:'',
                    fileId:this.$util.getUuid(),id:this.$util.getUuid(),supplierName:'',supplierNameTh:'',changeDes:''
                };
                 this.f.reformMainDetailList.push(a)
            },

            //删除一行
            delIndex(index){
                this.f.reformMainDetailList.splice(index, 1)
            },

            //增加一行个性化描述
            addIndividualize() {
                this.f.individualizeList.push('')
            },
            //减少一行性化描述
            deleteIndividualize(index) {
                this.f.individualizeList.splice(index, 1)
            },

            //增加一行标识要求
            addLogoRequest() {
                this.f.logoRequestList.push('')
            },
            //减少一行标识要求
            deleteLogoRequest(index) {
                this.f.logoRequestList.splice(index, 1)
            },
            getSupplier(v){
                reformService.getSupplier(v.materialCode).then( rd =>{
                    v.supplierName = rd.msg.supplierName;
                })
                reformService.getPurchaseGroup(v.materialCode).then( rd =>{
                    v.purchaseGroup = rd.msg.purchaseGroupCode;
                    v.unit = rd.msg.unit;
                })
            },
            getSupplierTh(v){
                reformService.getSupplier(v.materialCodeTh).then( rd =>{
                    v.supplierNameTh = rd.msg.supplierName;
                })
                reformService.getPurchaseGroup(v.materialCode).then( rd =>{
                    v.unitTh = rd.msg.unit;
                })
            },
            changeMb(row){
                console.log(row)
                //实际数量同步模板数量
                if(null == row.numbermb || row.numbermb == ''){
                    row.number = row.numberjs;
                }else {
                    row.number = row.numbermb;
                }
                //进行强制数据渲染
                this.$forceUpdate();
            },
            changeMbTh(row){
                console.log(row)
                //实际数量同步模板数量
                if(null == row.numbermbTh || row.numbermbTh == ''){
                    row.numberTh = row.numberjsTh;
                }else {
                    row.numberTh = row.numbermbTh;
                }
            },
            //调整单耗
            changeDh(row){
                console.log(row)
                row.numberjs =  new big(row.materialOrder).times(new big(this.f.number)).toString()
                row.numbermb = new big(row.materialOrder).times(new big(this.f.number)).toString()
                //实际数量同步模板数量
                if(null == row.numbermb || row.numbermb == '' ){
                    row.number = row.numberjs;
                }else if(null != row.numbermb && row.numbermb != ''){
                    row.number = row.numbermb;
                }
                //进行强制数据渲染
                this.$forceUpdate();
            },

        }
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }


    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
